// @ts-check
import LoadingContent from './LoadingContent';

export default LoadingContent;
